import { render, staticRenderFns } from "./LogInfo.vue?vue&type=template&id=fb8d23a0"
import script from "./LogInfo.vue?vue&type=script&lang=ts"
export * from "./LogInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports